import { arcToFixed } from '@src/core/extensions';
import { RouteWaypointEntity } from '@src/features/order/pages/upsert-mission-page/entities';

// Coordinates must keep ~6 decimals (~0.1 m); the default 2-decimal rounding (~1 km) would
// snap waypoints far from where they were placed and produce a "weird" route after Apply.
const COORD_PRECISION = 6;

export const roundWaypointCoords = (waypoints: RouteWaypointEntity[]): RouteWaypointEntity[] =>
  waypoints.map((wp) => ({
    ...wp,
    latitude: arcToFixed(wp.latitude, COORD_PRECISION),
    longitude: arcToFixed(wp.longitude, COORD_PRECISION),
    altitude: arcToFixed(wp.altitude),
  }));
